module.exports = __webpack_public_path__ + "static/media/bts2.7d905b1a.jpeg";